<template>
	<div>
		<div class="modal-header">
		    <div class="modal-title">
		        <a-icon type="medicine-box" style="margin-right:10px" />
		        <span>{{this.isEdit?l('Edit'):l('Create')}}</span>
		    </div>
		</div>
		<div>
		    <a-config-provider :locale="antdLocale">
				<a-row>
				    <a-col :span="24">
						<a-form-item required :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }"  :label="l('Name')">
							<a-input v-model="entity.name" class="input"></a-input>
						</a-form-item>
				    </a-col>
					<a-col :span="24">
					    <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('Code')">
					    	<a-input v-model="entity.code" class="input"></a-input>
					    </a-form-item>
					</a-col>
					<a-col :span="24">
					    <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 9 }" :label="l('pid')">
							<a-tree-select
							        v-model="pId"
							        style="width: 200px"
							        :tree-data="treeDataList"
							        :replace-fields="treeReplaceFields"
							        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
							        :placeholder="l('please_select_the_superior_node')"
							        allow-clear
							        tree-default-expand-all
							>
							</a-tree-select>
					    </a-form-item>
					</a-col>
				</a-row>
			</a-config-provider>
		</div>
		<div class="modal-footer" v-if="!isLook">
		    <a-button @click="close">
		        {{l('Cancel')}}
		    </a-button>
		    <a-button :type="'primary'" @click="save">
		        {{l('Save')}}
		    </a-button>
		</div>
	</div>
</template>

<script>
	import ModalComponentBase from '../../../../shared/component-base/modal-component-base';
	import zh_CN from 'ant-design-vue/lib/locale/zh_CN';
	import { AuditItemTemplateGroupServiceProxy } from '../../../../shared/service-proxies';
	
	let _this;
	export default {
		name: 'create-item',
		mixins: [ModalComponentBase],
		components: {
		    
		},
		created() {
		    this.fullData(); // 模态框必须,填充数据到data字段
		    this.AuditItemTemplateGroupServiceProxy = new AuditItemTemplateGroupServiceProxy(this.$apiUrl, this.$api);
		},
		mounted() {
		    this.getData();
			this.getTreeData();
		},
		data() {
		    return {
				zh_CN,
		        isEdit: false,//是否是编辑
		        isLook: false,//是否是查看
		        entity: [],
				pId: undefined,
				treeDataList: [],
				treeReplaceFields: {
				    title: 'name',
				    key: 'id',
				    value: 'id'
				},
				itemid: undefined,
				isclick: true,
				id: undefined
		    }
		},
		methods: {
			getData() {
				this.isLoading = true;
				this.AuditItemTemplateGroupServiceProxy.getForEdit(
					this.id
				).finally(() => {
					this.isLoading = false;
				}).then(res => {
					this.entity = res;
					if(this.entity.pId==0){
						this.pId = undefined;
					}else {
						this.pId=res.pId;
					}
				})
				
			},
			getTreeData() {
			    this.isLoading = true;
			    this.AuditItemTemplateGroupServiceProxy.getPaged(
			        undefined,
			    )
			        .finally(() => {
			            this.isLoading = false;
			        })
			        .then((res) => {
			            this.treeDataList = JSON.parse(JSON.stringify(res));
			        })
			},
			save() {
			    if (!this.entity.name) {
			        abp.message.info('分类名称不能为空');
			        return;
			    }
				
				if(this.pId==undefined) {
					this.entity.pId = 0;
				}else {
					this.entity.pId = this.pId;
				}
				var auditItemGroupEdit = {auditItemTemplateGroup:this.entity};
				if(this.isclick) {
					this.isclick = false;
					this.AuditItemTemplateGroupServiceProxy.createOrUpdate(
						auditItemGroupEdit
					).finally(() => {
					    this.close()
					}).then(res => {
						this.isclick = true;
					    this.success(true)
					})
				}
			
			},
			
		}
	}
</script>

<style>
	.input {
		width: 200px;
	}
</style>
